export default __webpack_public_path__ + "a42f43abb39ae89c6d8fc4e32d82c9db.png";